export const ENABLE_FEATURE_FLAG_OVERRIDE_KEY = "enable-feature-flag-override";
export const FEATURE_FLAG_IDS = [
  ENABLE_FEATURE_FLAG_OVERRIDE_KEY,
  "enable-scenario-page",
  "enable-inventory-bisko-informational",
  "enable-climate-action-upload",
  "enable-milestone-tab",
  "enable-key-results-view",
  "enable-key-results",
  "enable-scenario-with-climate-actions",
  "enable-reduction-levers",
  "enable-feature-flag-page",
  "enable-export-inventory-evaluation",
  "enable-csv-export",
  "enable-datatable-csv-export",
  "enable-notification-settings",
  "enable-update-recency-chart",
  "enable-assignment-emails",
  "enable-fluid-engine",
  "enable-inventory-csv-upload",
  "enable-climate-action-indicator-list-page",
  "enable-i18n",
  "enable-label-group-creation",
  "enable-timeline-tab",
  "enable-board-tab",
  "enable-dashboard-template-v2",
  "enable-status-settings-page",
  "enable-analytics-dashboard-charts",
  "enable-permission-v2",
  "enable-workspace-search-bar",
  "enable-entity-bulk-delete-column",
  "enable-manual-workspace-invite",
  "enable-indicator-csv-import",
  "enable-climate-action-total-row",
  "enable-project-total-row",
  "enable-task-total-row",
  "enable-column-drag-and-drop",
  "enable-realtime-collaboration",
  "enable-data-request",
  "enable-project-upload",
  "enable-object-metadata-capture",
  "enable-dashboard-translations",
  "enable-dashboard-template-editor",
  "enable-energy-production-model",
  "enable-climate-action-catalogue",
  "enable-climate-action-suggestions",
  "enable-exact-mode-in-emissionfactors",
  "enable-admin-analytics",
  "enable-admin-user-management",
  "enable-migrate-dashboard",
  "debug-dashboard-speed",
  "enable-gpc-inventories",
  "enable-ghg-for-administrations-inventory",
  "enable-public-dashboard-astro",
  "enable-public-host-clean-url",
  "enable-grant-suggestions",
  "enable-force-reload-fundings",
  "enable-ksp-import",
  "enable-scenario-comparison",
  "enable-fix-queue-button-scenario",
  "enable-small-value-grouping",
  "enable-cost-reduction-calculator",
  "enable-trash",
  "enable-offering",
  "enable-ageb-data",
  "enable-liegenschaften",
  "enable-liegenschaften-consumption",
] as const;
export type FeatureFlagIDs = (typeof FEATURE_FLAG_IDS)[number];
